import React from 'react';
import { useTranslation } from 'react-i18next';
import { WeatherData } from '../../../types/weather';
import WeatherIcon from '../WeatherIcon';
import { Wind, Droplet, Thermometer } from 'react-feather';

interface Props {
  data: WeatherData;
}

const WeatherCard: React.FC<Props> = ({ data }) => {
  const { t, i18n } = useTranslation();

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString(i18n.language, {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200 transform hover:-translate-y-1">
      <div className="text-sm font-medium text-gray-500 mb-3 border-b pb-2">
        {formatDate(data.date)}
      </div>
      <div className="flex flex-col items-center mb-3">
        <WeatherIcon description={data.description} size="md" />
        <span className="text-xl font-semibold text-gray-900 mt-2">{data.temperature}°C</span>
      </div>
      <div className="space-y-2 text-sm text-gray-600">
        {data.rainfall > 0 && (
          <div className="flex items-center">
            <Droplet className="h-4 w-4 mr-2 text-blue-500" />
            <span>{t('weather.rainfall')}: {data.rainfall.toFixed(1)} mm</span>
          </div>
        )}
        <div className="flex items-center">
          <Wind className="h-4 w-4 mr-2 text-blue-400" />
          <span>{t('weather.windSpeed')}: {data.windSpeed} km/h</span>
        </div>
      </div>
    </div>
  );
};

export default WeatherCard;